import { QueryClient } from '@tanstack/react-query';

import { queryCache } from '@/shared/api/queryCache';

export const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
  queryCache,
});
